// @ai-generated 2026-08-19T06:57:20+00:00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import { hasUnsuccessfulMessage, readToolResultPayload } from '@utils/toolCallEnvelope';
/**
 * Shared status vocabulary for the two views that list tool calls — `ChatToolCallCard` and
 * `ToolCallSidebar` — so they cannot disagree about which calls failed.
 */

/**
 * Whether an MCP tool result reports a failure. Reads `isError` off the serialized `CallToolResult`,
 * because a rejected command still completes and so completion says nothing about the outcome.
 *
 * Accepts the parsed object or the JSON string, since the two views receive different shapes.
 * Anything unrecognised counts as success: showing red wrongly misleads as much as showing green.
 */
export function hasToolError(result: unknown): boolean {
    const payload = readToolResultPayload(result);
    if (typeof payload === 'object' && payload !== null && (payload as { isError?: unknown }).isError === true) {
        return true;
    }

    // The flag rides on the CallToolResult wrapper, which a single-block result loses before it
    // reaches the chat; the envelope's own messages are then the only evidence of a failure.
    return hasUnsuccessfulMessage(result);
}

/** Selects a class in `toolCallTone.module.css`, which owns the colours the tone is drawn in. */
export type ToolCallTone = 'running' | 'succeeded' | 'failed';

export interface ToolCallState {
    isRunning: boolean;
    isFailed: boolean;
    tone: ToolCallTone;
    statusLabel: string;
}

/**
 * Resolves a tool call's lifecycle status and its result into the one state both the fallback card
 * and the specialized ones display, so they cannot disagree about which calls failed.
 */
export function resolveToolCallState(status: unknown, result: unknown): ToolCallState {
    const statusString = String(status);
    const isRunning = statusString === 'inProgress' || statusString === 'executing';
    const isFailed = !isRunning && hasToolError(result);

    return {
        isRunning,
        isFailed,
        tone: isRunning ? 'running' : isFailed ? 'failed' : 'succeeded',
        statusLabel: isRunning ? 'läuft' : isFailed ? 'fehlgeschlagen' : 'erledigt',
    };
}
